import {  HmInstanceApiRequest, withMock } from 'api';
import { connectHttp } from '.';

const connectMock = () => import(/* webpackChunkName: "mockApi" */ './config.mock');

export const getInstanceConnections: HmInstanceApiRequest =
  ({ wildcard }, options = {}) =>
    withMock(connectHttp.url(`/config/${wildcard}`), options, connectMock)
      .get();